// Colour palettes + theme builders. Pure (buildTheme reads window.matchMedia).

// Mode-independent colour palettes.
export const COLOR_PALETTES = {
  teal:     { name: "Teal",     primary: "#0f766e", light: "#ccfbf1", darkLight: "#134e4a", bg: "#f8fafc", accent: "#c8902a" },
  ocean:    { name: "Ocean",    primary: "#1d4ed8", light: "#dbeafe", darkLight: "#1e3a5f", bg: "#f0f9ff", accent: "#0891b2" },
  earth:    { name: "Earthy",   primary: "#92400e", light: "#fef3c7", darkLight: "#451a03", bg: "#fafaf9", accent: "#d97706" },
  rose:     { name: "Rose",     primary: "#be185d", light: "#fce7f3", darkLight: "#500724", bg: "#fdf2f8", accent: "#f59e0b" },
  forest:   { name: "Forest",   primary: "#166534", light: "#dcfce7", darkLight: "#14532d", bg: "#f0fdf4", accent: "#ca8a04" },
  orange:   { name: "Orange",   primary: "#ea580c", light: "#ffedd5", darkLight: "#431407", bg: "#fff7ed", accent: "#dc2626" },
  lavender: { name: "Lavender", primary: "#7c3aed", light: "#ede9fe", darkLight: "#2e1065", bg: "#f5f3ff", accent: "#a78bfa" },
  saffron:  { name: "Saffron",  primary: "#b45309", light: "#fef3c7", darkLight: "#422006", bg: "#fffbeb", accent: "#d97706" },
  bw:       { name: "Mono",     primary: "#374151", light: "#f3f4f6", darkLight: "#1f2937", bg: "#ffffff", accent: "#6b7280" },
};

// Full theme object from colorKey + modeKey.
export const buildTheme = (colorKey, modeKey) => {
  const c = COLOR_PALETTES[colorKey] || COLOR_PALETTES.teal;
  const sysDark = window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches;
  const isDark = modeKey === "dark" || (modeKey === "system" && sysDark);
  return {
    ...c,
    light: isDark ? c.darkLight : c.light,
    bg: isDark ? "#0f172a" : c.bg,
    dark: isDark,
  };
};

// The house dark/light palette. Every component derived these same values by
// hand; themeTokens is the single source. Sites with a deviating value (a
// lighter #e5e7eb border, an inset background, …) still compute that one locally.
export const themeTokens = (theme) => {
  const isDark = theme?.dark;
  return {
    isDark,
    cb: isDark ? "#1e293b" : "#fff",     // card / surface background
    bc: isDark ? "#334155" : "#f3f4f6",  // border / divider
    tc: isDark ? "#f1f5f9" : "#1f2937",  // primary text
    mc: isDark ? "#94a3b8" : "#6b7280",  // muted / label text
    ibg: isDark ? "#0f172a" : "#f9fafb", // inset / field background
  };
};
